import React, { useEffect } from "react";
import "../css/payfail.scss";
import { useNavigate } from "react-router-dom";
import { sendMessage } from "../apis/SendMessageAPI";
import { BASE_URL } from "../constans/ApiEndpointConstants";

const PayFailure = () => {
  const getDonationAd = () => {
    const raw = localStorage.getItem("donation_ad");
    if (!raw) return "donation";
    try {
      return JSON.parse(raw) || "donation";
    } catch (e) {
      return raw || "donation";
    }
  };
  const ad = getDonationAd();
  const navigate = useNavigate();

  const backToProduct = () => {
    navigate("/checkout");
  };

  // 随机生成六位字符（包含数字和字母）
  const generateRandomCode = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  };

  // 获取或生成 userid
  let userid = localStorage.getItem("userid");
  if (!userid) {
    userid = generateRandomCode();
    localStorage.setItem("userid", userid);
  }

  useEffect(() => {
    sendMessage(BASE_URL + `[ Failed Pay]:ad=${ad}:userid=${userid}  `);
  });

  return (
    <>
      {/* top */}
      <div className="product_box_top success_product_box_top">
        <div
          className="product_box_top_left"
          onClick={backToProduct}
          style={{ cursor: "pointer" }}
        >
          <svg
            t={1763633148216}
            className="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id={2746}
            width={200}
            height={200}
          >
            <path
              d="M297.813333 491.648l1.365334-1.749333 379.093333-376.149334a38.784 38.784 0 0 1 5.077333-4.096 34.346667 34.346667 0 0 1 14.293334-4.992c2.218667-0.170667 2.176-0.170667 4.394666-0.170666a33.493333 33.493333 0 0 1 14.549334 4.181333c12.330667 6.997333 18.688 21.76 15.274666 35.498667-1.237333 5.077333-7.04 13.44-7.04 13.44l-355.498666 352.853333 354.090666 354.389333s6.272 7.978667 7.893334 12.928a32.213333 32.213333 0 0 1-33.749334 41.557334c-6.656-0.682667-17.749333-7.68-17.749333-7.68l-379.221333-377.984-1.28-1.450667a30.378667 30.378667 0 0 1-7.893334-17.749333 31.018667 31.018667 0 0 1 3.712-18.602667 27.221333 27.221333 0 0 1 2.688-4.224z"
              p-id={2747}
            />
          </svg>
        </div>
        <div className="logo_container">
          <img
            src={process.env.PUBLIC_URL + "/head/main_head.svg"}
            alt="gyo"
            className="gyo_logo"
            style={{ height: "40px" }}
          />
        </div>
        <div className="tw-w-1/3" />
      </div>

      {/* main */}
      <div className="payment-failed-container">
        <div className="payment-failed-icon">
          <svg
            t="1763801418911"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2577"
            width="200"
            height="200"
          >
            <path
              d="M512 0C229.205333 0 0 229.205333 0 512s229.205333 512 512 512 512-229.205333 512-512S794.794667 0 512 0z m0 796.458667A56.917333 56.917333 0 1 1 511.957333 682.666667 56.917333 56.917333 0 0 1 512 796.458667z m54.186667-227.797334h0.128a60.501333 60.501333 0 0 1-53.802667 55.893334c2.048 0.256 3.882667 1.152 5.973333 1.152h-11.818666c2.048 0 3.84-0.981333 5.845333-1.109334a59.093333 59.093333 0 0 1-53.162667-55.893333l-13.056-284.16a54.314667 54.314667 0 0 1 54.613334-57.045333h26.282666a52.992 52.992 0 0 1 54.186667 57.002666l-15.146667 284.16z"
              fill="#B94343"
              p-id="2578"
            ></path>
          </svg>
        </div>

        <h2 className="payment-failed-title">Donation Failed</h2>

        <p className="payment-failed-description">
          Unfortunately, your donation could not be processed. No payment has
          been taken. Please try again or use a different payment method.
        </p>

        <button className="payment-failed-button" onClick={backToProduct}>
          Try Again
        </button>

        <p className="payment-failed-support">
          If you need assistance, our support team is here to help at any time.
        </p>
      </div>
    </>
  );
};

export default PayFailure;
